import { useXHR } from "@sembark-travel/xhr"

import { VisaServiceForm } from "./Item"
import { TVisaServiceForm, XHR } from "./store"
import { useState } from "react"
import { showSnackbar } from "@sembark-travel/ui-snackbar"

export function NewVisaService({
	onSuccess,
	onCancel,
}: Readonly<{
	onSuccess: () => void
	onCancel?: () => void
}>) {
	const xhr = useXHR()
	return (
		<NewVisaServiceForm
			onSubmit={async (values: TVisaServiceForm) => {
				await XHR(xhr).createVisaService(values)
				showSnackbar(`The visa service has been created successfully!`)
				onSuccess()
			}}
			onCancel={onCancel}
		/>
	)
}

export function NewVisaServiceForm({
	onSubmit,
	onCancel,
}: Readonly<{
	onSubmit: (data: TVisaServiceForm) => Promise<void>
	onCancel?: () => void
}>) {
	const [initialValues] = useState<TVisaServiceForm>(() => ({
		countries: [],
		destinations: [],
		name: undefined,
		currency: "INR",
		document_groups: undefined,
		visa_types: [
			{
				name: undefined,
				type_of_visa: undefined,
				day_and_hour: undefined,
				duration: undefined,
				entry_type: undefined,
				purpose: undefined,
				cost_price: undefined,
				selling_price: undefined,
				price_valid_till: undefined,
				apply_before_days: undefined,
				description: undefined,
				document_groups: undefined,
			},
		],
	}))

	return (
		<VisaServiceForm
			onSubmit={onSubmit}
			onCancel={onCancel}
			initialValues={initialValues}
		/>
	)
}
